import styled from 'styled-components'

// import theme from 'configs/theme'

const Styled = styled.div`
  textarea {
    border-radius: 10px;
  }
`

export default Styled
